import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps, RecipeVariant } from '@allenai/varnish-panda-runtime/types';

const alertRecipe = sva({
    slots: ['root', 'icon', 'title', 'message', 'actions', 'closeButton'],
    base: {
        root: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '1',
            border: '1px solid transparent',
            borderRadius: 'sm',
            padding: '[8px]',
            width: '[100%]',
        },
        icon: {
            display: 'flex',
            fontSize: '[22px]',
            lineHeight: '1',
        },
        title: {
            margin: '0',
        },
        message: {
            flexGrow: '1',
            fontSize: 'sm',
        },
        actions: {},
        closeButton: {
            appearance: 'none',
            backgroundColor: 'transparent',
            border: '0',
            padding: '0',
            fontSize: '[22px]',
            lineHeight: '1',
            display: 'flex',
        },
    },
    variants: {
        severity: {
            // the `colorPalette` property is a "virtual color" (see: https://panda-css.com/docs/concepts/virtual-color)
            // we can point it at the root of the token heierarchy, and then reference the tokens below
            // by setting `colorPalette: 'elements.confirmation'`,
            // `color: 'colorPalette.fill` will poinr to `elements.confirmation.fill` (in this example)
            // this can now be used elsewhere in the varaints, see outlined and contained variant
            success: {
                root: {
                    colorPalette: 'elements.confirmation',
                    color: 'colorPalette.fill',
                },
            },
            info: {
                root: {
                    colorPalette: 'elements.information',
                    color: 'colorPalette.fill',
                },
            },
            warning: {
                root: {
                    colorPalette: 'elements.warning',
                    color: 'colorPalette.fill',
                },
            },
            error: {
                root: {
                    colorPalette: 'elements.error',
                    color: 'colorPalette.fill',
                },
            },
        },
        variant: {
            // These variants can rely on us setting `colorPalette` in the `severity` variant above
            // so, now the borderColor gets set to the correct stroke with this single line:
            outlined: {
                root: {
                    borderColor: 'colorPalette.stroke',
                },
            },
            // same idea applies here:
            contained: {
                root: {
                    backgroundColor: 'colorPalette.fill',
                    color: 'colorPalette.contrast',
                },
            },
        },
    },
    defaultVariants: {
        severity: 'info',
        variant: 'contained',
    },
});

type AlertRecipeProps = RecipeVariantProps<typeof alertRecipe>;
type AlertRecipeVariantProps = RecipeVariant<typeof alertRecipe>;
type AlertSeverity = AlertRecipeVariantProps['severity'];

export { alertRecipe, alertRecipe as default };
export type { AlertRecipeProps, AlertRecipeVariantProps, AlertSeverity };
